
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transportation",
      function () {
        return require("private-next-pages/transportation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transportation"])
      });
    }
  